/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component } from '@angular/core';

@Component({
    selector: 'dash-gis-markup-bottom-sheet',
    template: ``,
})
export class MarkupBottomSheetComponent {}
